var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"id":"pdf-box"}},[_c('co-loadProcess',{ref:"loadProcess",on:{"loadingAction":_vm.loadingAction}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }